// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__2p9Z5","summary":"CartItem_summary__12KGk","price":"CartItem_price__-RDhX","amount":"CartItem_amount__1DInx","actions":"CartItem_actions__1WY42"};